const padding = {
    large: '9.6rem',
    medium: '4.8rem',
    small: '1.6rem'
}

const colors = {
    white: '#F7F7F7',
    black: '#111111',
    gray30: '#4D4D4D',
    gray50: '#808080',
    green: '#AAAE8C',
    orange: '#C4865D'
}

const typography = {
    titleFont: '"Cirka", -apple-system, serif',
    bodyFont: '"Aileron", -apple-system, sans-serif',
    defaultSize: '1.6rem'
}

const variables = {
    padding: padding,
    color: colors,
    typography: typography
}

export default variables